import { useNavigate } from 'react-router-dom';
import { StyledHeader, MenuBlock, LogoContainer, Logo } from './styles';

export function Header() {
  const navigate = useNavigate(); 

  const handleLogoClick = () => {                                                                        
    navigate('/diagnosis');
  };

  return (
    <StyledHeader>
      <MenuBlock>
        <LogoContainer>
          <Logo src="/assets/logos/logo.png" onClick={handleLogoClick} />
        </LogoContainer>
      </MenuBlock>
    </StyledHeader>
  );
}